<template>
  <div>
    <div v-scroll-hint class="table-responsive reports-table">
      <div ref="body">
        <table class="ld-table ld-table-header-blue">
          <thead>
            <tr>
              <th>Imported on</th>
              <th>With this file</th>
              <th>By</th>
              <th>Leaves imported</th>
              <th>Errors report</th>
              <th>Undo import</th>
            </tr>
          </thead>
          <template v-if="imports.length">
            <LeaveImportTimelineTableRow
              v-for="row in imports"
              :key="row.id"
              :row="row"
              @download="$emit('download', $event)"
              @undo="$emit('undo', $event)"
            />
          </template>
          <tbody v-if="!loading && !imports.length">
            <tr>
              <td class="tw-bg-white" colspan="6">
                <NoData />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <Loading
        :blur="null"
        loader="dots"
        :is-full-page="false"
        :active.sync="loading"
        :container="$refs.body"
        class="tw-mt-12"
      />
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'

const NoData = () => import('@/components/NoData')
const LeaveImportTimelineTableRow = () =>
  import(
    '@/components/reports/leave-import-timelines/LeaveImportTimelineTableRow'
  )

export default {
  name: 'LeaveImportTimelineTable',

  components: {
    NoData,
    Loading,
    LeaveImportTimelineTableRow,
  },

  props: {
    imports: {
      type: Array,
      required: true,
    },

    loading: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
